import { Component, ElementRef, Inject, PLATFORM_ID, AfterViewInit, ViewChild, HostListener, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { forkJoin } from 'rxjs';

import { ProductService } from '@services/product.service';
import { GlobalService } from '@services/global.service';
import { RouteService } from '@services/route.service'; // Importé pour la navigation
import { Product } from '@models/product';
import { environment } from '@environments/environment';

@Component({
  selector: 'gob-goldn-gob',
  templateUrl: './goldn-gob.component.html',
  styleUrls: ['./goldn-gob.component.scss']
})
export class GoldnGobComponent implements OnInit, AfterViewInit {

  @ViewChild('listeRef') listeRef: ElementRef;

  laureats: any[] = [];
  laureatsBase: any[] = [];
  
  imageErrors: { [key: number]: boolean } = {};
  isMobile: boolean = false;
  derniereAnnee: string = '';
  loading: boolean = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private pServ: ProductService,
    private gServ: GlobalService,
    public route: RouteService // Injecté comme dans home-selection
  ) { }

  ngOnInit(): void {
    this.fetchData();
  }

  fetchData() {
    this.loading = true;
    forkJoin({
      products: this.pServ.getSelected(),
      categs: this.gServ.getCategs()
    }).subscribe(values => {
      const goldnGobProducts = values.products.goldnGob || [];
      this.processDerniersLaureats(goldnGobProducts);
      this.updateDataDisplay();
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  processDerniersLaureats(products: Product[]) {
    const groups: { [year: string]: any[] } = {};
    
    products.forEach(p => {
      p.banners.forEach((b) => {
        if (b.name && b.name === 'Gold\'n\'Gob') {
          if (b.start && b.start !== '0000-00-00') {
            const d = new Date(b.start);
            if (!isNaN(d.getTime())) {
              const year = d.getFullYear().toString();
              if (!groups[year]) groups[year] = [];
              groups[year].push(this.mapProductToItem(p));
            }
          }
        }
      });
    });

    const sortedYears = Object.keys(groups).sort((a, b) => Number(b) - Number(a));
    if (sortedYears.length > 0) {
      this.derniereAnnee = sortedYears[0];
      this.laureatsBase = groups[this.derniereAnnee];
    }
  }

  mapProductToItem(p: Product) {
    let cleanName = p.name || '';
    cleanName = cleanName.replace(/-?\s*Gold.*?202\d/i, '').replace(/\s+202\d$/, '').trim();

    return {
      ident: p.ident,
      nom: cleanName,
      img: this.getProductImage(p)
    };
  }

  getProductImage(prod: Product): string {
    if (prod.mainImage && prod.mainImage.name) {
      return `${environment.imgUrl}/product/${prod.mainImage.name}`;
    } else if (prod.images && prod.images.length > 0) {
      return `${environment.imgUrl}/product/${prod.images[0].name}`;
    }
    return 'assets/img/logo/logo.png';
  }

  onImageError(productId: number): void {
    this.imageErrors[productId] = true;
  }

  @HostListener('window:resize')
  onResize() {
    this.updateDataDisplay();
  }

  updateDataDisplay() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile && this.laureatsBase.length > 0) {
        this.laureats = [...this.laureatsBase, ...this.laureatsBase, ...this.laureatsBase];
      } else {
        this.laureats = [...this.laureatsBase];
      }
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && this.listeRef) {
      setTimeout(() => {
        const el = this.listeRef.nativeElement;
        if (this.isMobile && el.scrollWidth > el.clientWidth) {
          el.scrollLeft = el.scrollWidth / 3;
        }
      }, 500);
    }
  }

  gererScrollInfini(event: any) {
    if (!this.isMobile) return;
    const el = event.target;
    const oneSetWidth = el.scrollWidth / 3;
    if (el.scrollLeft < 50) {
       el.scrollLeft += oneSetWidth;
    } else if (el.scrollLeft >= oneSetWidth * 2 - 50) {
       el.scrollLeft -= oneSetWidth;
    }
  }
}